import * as React from 'react';

import { translate } from '~l10n/client';

import { SmallButton } from '~shared/components/buttons';
import { QrCode, useQrCodeMaxWidth } from '~shared/components/QrCode';
import { useRoomDetail } from '~teacher/hook/room/useRoomDetail';

interface Props {
  roomId: number;
}

const MAX_QR_CODE_WIDTH = 420;

export function ShareRoomQrCode({ roomId }: Props) {
  const roomDetail = useRoomDetail({ roomId: roomId });

  const canvasRef = React.useRef<HTMLCanvasElement>();

  const downloadQrCode = () => {
    const url = canvasRef.current.toDataURL('image/png');
    const link = document.createElement('a');
    link.download = `${roomDetail.data.name}-qr-code.png`;
    link.href = url;
    link.click();
  };

  const qrCodeWidth = useQrCodeMaxWidth(MAX_QR_CODE_WIDTH);

  return (
    <div className="flex flex-col gap-8">
      <div className="flex flex-row">
        <SmallButton onClick={downloadQrCode}>
          {translate('Download QR Code')}
        </SmallButton>
      </div>
      <div className="flex justify-center">
        <QrCode
          key={`${qrCodeWidth}-${roomDetail.data?.name}`}
          size={qrCodeWidth}
          text={roomDetail.data?.url + '?method=qr'}
          ref={canvasRef}
          data-testid="qr-code"
        />
      </div>
    </div>
  );
}
